import { AirplaneTilt, Bed, Car, Info, MapPinLine, PlusCircle, PushPin } from 'components/shared/Icon/phosphorIcons';
import {
  PAGE_TYPE_ABOUT_SAFARI,
  PAGE_TYPE_ABOUT_US,
  PAGE_TYPE_ACTIVITY,
  PAGE_TYPE_AREA,
  PAGE_TYPE_MISC,
  PAGE_TYPE_PRE_TRAVEL_INFO,
  PAGE_TYPE_PROPERTY,
} from 'constants/index';
import { ETripEvent } from 'detailsv2/structure';

import { IAction } from '../ActionsMenu/types';
import { ETimelineWarningType, ITimelineWarning, ITripEventCreateAction } from './types';

export const addEventActions: ITripEventCreateAction[] = [
  {
    title: 'Flight',
    type: ETripEvent.Flight,
    icon: AirplaneTilt,
    onClick: () => {},
  },
  {
    title: 'Transfer',
    type: ETripEvent.Transfer,
    icon: Car,
    onClick: () => {},
  },
  {
    title: 'Area',
    type: ETripEvent.Area,
    icon: MapPinLine,
    onClick: () => {},
  },
  {
    title: 'Accommodation',
    type: ETripEvent.Accommodation,
    icon: Bed,
    onClick: () => {},
  },
  {
    title: 'Activity',
    type: ETripEvent.Activity,
    icon: PushPin,
    onClick: () => {},
  },
  {
    title: 'Information',
    type: ETripEvent.Information,
    icon: Info,
    onClick: () => {},
  },
];

export const mergeEventsAction: IAction = {
  title: 'Insert Itinerary',
  icon: PlusCircle,
  onClick: () => {},
};

export const activityLoadTypes = [
  PAGE_TYPE_AREA,
  PAGE_TYPE_MISC,
  PAGE_TYPE_PRE_TRAVEL_INFO,
  PAGE_TYPE_ABOUT_SAFARI,
  PAGE_TYPE_ACTIVITY,
  PAGE_TYPE_ABOUT_US,
];

export const areaLoadTypes = [PAGE_TYPE_AREA, PAGE_TYPE_MISC, PAGE_TYPE_PRE_TRAVEL_INFO, PAGE_TYPE_ABOUT_SAFARI];

export const infoLoadTypes = [
  PAGE_TYPE_AREA,
  PAGE_TYPE_MISC,
  PAGE_TYPE_PRE_TRAVEL_INFO,
  PAGE_TYPE_ABOUT_SAFARI,
  PAGE_TYPE_ACTIVITY,
  PAGE_TYPE_ABOUT_US,
];

export const transferLoadTypes = [
  PAGE_TYPE_AREA,
  PAGE_TYPE_ACTIVITY,
  PAGE_TYPE_PROPERTY,
  PAGE_TYPE_MISC,
  PAGE_TYPE_ABOUT_US,
  PAGE_TYPE_ABOUT_SAFARI,
  PAGE_TYPE_PRE_TRAVEL_INFO,
];

export enum EFlightSearchTypes {
  FLIGHT_NUMBER = 'Flight Number',
  ROUTE = 'Route',
  MANUAL = 'MANUAL',
}

export const searchTypes = [EFlightSearchTypes.FLIGHT_NUMBER, EFlightSearchTypes.ROUTE];

export const timelineWarningsMap: Record<ETimelineWarningType, ITimelineWarning> = {
  [ETimelineWarningType.EMPTY_DAYS]: {
    type: ETimelineWarningType.EMPTY_DAYS,
    message: 'Some days do not have any events added.',
  },
  [ETimelineWarningType.WRONG_FLIGHT_INFO]: {
    type: ETimelineWarningType.WRONG_FLIGHT_INFO,
    message: 'You have flight information that may not be accurate.',
  },
  [ETimelineWarningType.RELEVANT_PRIMARY_PHOTO]: {
    type: ETimelineWarningType.RELEVANT_PRIMARY_PHOTO,
    message:
      'You’ve modified the itinerary. Remember to check that the primary photos you had previously selected are still relevant.',
  },
};

export const ACTIVE_TRIP_EVENT_ID_QUERY_PARAM = 'activeTripEventId';
